<!--
일반검수 레이아웃 (24년 5월버전) >
상품1개 정보
------------------------------------
-->
<template>
    <div class="uk-flex uk-flex-top uk-flex-left prod-row">
        <!-- 체크박스 -->
        <app-batch-item-checker
            :item="prod.checkbox"
            v-if="prod.checkbox"
            :disabled="disableCheckbox"
        ></app-batch-item-checker>
        <input type="checkbox" class="uk-checkbox" v-if="! prod.checkbox" disabled/>


        <!-- 이미지 -->
        <div class="col-img uk-margin-small-left">
            <img-zoom :src="prod.img_url" style="width: 15rem; height: 15rem"></img-zoom>


        </div>

        <!-- 나머지 영역 -->
        <div class="uk-width-expand">
            <!-- 정보 라인 -->
            <div class="uk-flex uk-flex-top uk-flex-left">

                <div class="col-1">
                    <!-- 상품정보 -->
                    <table class="">
                        <colgroup>
                            <col style="width: 5rem;">
                            <col style="width: 10rem;">
                            <col style="width: 5rem;">
                            <col>
                        </colgroup>
                        <tr>
                            <th class="highlight">
                                <i class="material-icons">
                                    star
                                </i>
                                NAME
                            </th>
                            <td class="highlight name" colspan="3">
                                {{ prod.name }}
                                <app-column
                                    header="상품명(영문)"
                                    horizontal
                                    header-align="right"
                                    body-align="left"
                                    body-size="medium"
                                    v-show="prod.name_eng"
                                >
                                    {{ prod.name_eng }}
                                </app-column>
                            </td>
                        </tr>
                        <tr>

                            <th class="highlight">
                                <i class="material-icons">
                                    star
                                </i>
                                COLOR
                            </th>
                            <td class="highlight color" colspan="3">
                                {{ prod.color }}
                            </td>
                        </tr>
                        <tr>
                            <th class="highlight">
                                <i class="material-icons">
                                    star
                                </i>
                                SIZE
                            </th>
                            <td class="highlight size" colspan="3">
                                <div>
                                    {{ prod.size }}
                                </div>

                                <!-- 신발검수 안내 -->
                                <div class="shoes-guide" v-if="isShoes">
                                    cm(센티미터) 사이즈 틀리면 오류처리

                                    <a class="uk-button uk-button-xsmall uk-button-white"
                                       v-if="isShoes"
                                       href="https://global.gonelo.com/common/warehouse_faqs/25"
                                       target="_blank"
                                    >
                                        FAQ 보러가기
                                    </a>
                                </div>


                            </td>
                        </tr>
                        <tr>
                            <th :class="prod.amount > 1 ? 'highlight' : ''">
                                <i class="material-icons">
                                    star
                                </i>
                                QTY
                            </th>
                            <td class="amount" :class="prod.amount > 1 ? 'highlight' : ''">
                                {{ prod.amount }}
                            </td>

                            <th :class="prod.vender_code ? 'highlight' : ''">
                                <i class="material-icons">
                                    star
                                </i>
                                SKU / <br/>
                                Item no.
                            </th>
                            <td class="sku" :class="prod.vender_code ? 'highlight' : ''">
                                {{ prod.vender_code }}

                                <div class="sku-warning" v-if="prod.vender_code">
                                    주의! SKU 번호 불일치시 오류처리 하세요
                                </div>
                            </td>
                        </tr>


                    </table>

                </div>


                <div class="col-2">
                    <table>
                        <colgroup>
                            <col style="width: 5rem;">
                            <col>
                            <col style="width: 24rem;">
                        </colgroup>

                        <tr>
                            <th>
                                <i class="material-icons">
                                    attach_money
                                </i>
                                단가
                            </th>
                            <td class="unit-price">
                                {{ prod.unit_price_text }}
                                <div v-show="expensived" class="expensived">고가제품 검수 주의</div>
                            </td>

                            <td>

                                <!-- 해외상세 -->
                                <a class="uk-button uk-button-small uk-button-white"
                                   target="_blank"
                                   :href="prod.vender_url"
                                >
                                    <i class="material-icons">store</i> 해외상세
                                </a>

                                <a class="uk-button uk-button-small uk-button-white ml-0d5rem prod-detail-button"
                                   target="_blank"
                                   :href="'/prods/' + prod.id"
                                >
                                    <i class="material-icons">link</i> 상품상세
                                    <div class="prod-id">{{ prod.id }}</div>
                                </a>

                                <a class="uk-button uk-button-small uk-button-dark ml-0d5rem"
                                   target="_blank"
                                   :href="'/prods/' + prod.id + '/files'"
                                >
                                    <i class="material-icons">linked_camera</i> PHOTO
                                </a>
                            </td>
                        </tr>

                        <!-- 보류요청 -->
                        <tr v-if="displayHoldButton">
                            <th :class="prod.hold_request.hold_reason ? 'highlight' : null">
                                <i class="material-icons">
                                    star
                                </i>
                                보류요청
                            </th>
                            <td colspan="2" class="p-0">
                                <request
                                    v-if="prod.hold_request"
                                    :request="prod.hold_request.hold_reason"

                                    style="background-color: #f6c6ad"
                                >
                                    <template slot="none">
                                        <div class="uk-text-muted app-background-white">보류요청 사항 없음</div>
                                    </template>
                                </request>
                            </td>
                        </tr>


                        <!-- 검수요청사항 -->
                        <tr v-if="prod.check_requests.length > 0">
                            <th :class="prod.check_requests.length > 0 ? 'highlight' : null">
                                <i class="material-icons">
                                    star
                                </i>
                                검수요청
                                <div v-if="prod.check_requests.length > 1">({{ prod.check_requests.length }})</div>
                            </th>
                            <td colspan="2" class="p-0">
                                <request
                                    v-for="req in prod.check_requests"
                                    :key="req.id"
                                    :request="req.request"
                                    class="req-msg"
                                ></request>
                            </td>
                        </tr>
                    </table>


                    <div class="uk-flex uk-flex-left uk-margin-top">
                        <!-- 보류안내 -->
                        <div v-if="displayHoldButton">
                            <div class="uk-text-primary uk-text-medium3 uk-margin-small-bottom">
                                <i class="material-icons">
                                    info
                                </i>
                                보류요청 상품입니다.
                            </div>

                            <div class="hold-job-guide">
                                <span class="strong">검수</span>
                                후 <span class="strong">[오류]</span> 또는 <span class="strong">[보류보관]</span> 처리하시고,
                                <span class="strong">[인보이스+리턴레이블]</span>
                                상품과 함께 보관해 주세요.
                            </div>
                        </div>
                    </div>


                </div>
            </div>

            <!-- 버튼 라인 -->
            <div class="uk-flex uk-flex-top uk-flex-left uk-flex-bottom uk-margin-small-top">
                <div class="col-1">
                    <div class="uk-flex uk-flex-right uk-flex-bottom">
                        <!-- 검수대상 카운트 -->
                        <div
                            v-if="prodTotalCountInTracking > 0"
                            class="uk-width-auto prod-count-guide uk-margin-right"
                            :class="prodTotalCountInTracking > 1 ? 'multi' : ''"
                        >
                            검수대상
                            <span class="current">{{ prodIndexInTracking }}</span>
                            /
                            <span class="total">{{ prodTotalCountInTracking }}</span>
                        </div>

                        <!-- 정상 -->
                        <div>
                            <button
                                v-if="displayOkButton"
                                class="uk-button uk-button-primary uk-button-large"
                                @click="$refs.ok.form()"
                            >
                                <i class="material-icons">check</i>
                                정상
                                <span v-if="mergedShipping">(발송대기)</span>
                            </button>
                            <app-check-set-ok
                                ref="ok"
                                :csrf-token="csrfToken"
                                :prod-id="prod.id"
                                @done:ready="callbackReady"
                                @done:pack="house_id => callbackPack(house_id)"
                            >
                            </app-check-set-ok>
                        </div>


                        <!-- 보류 -->
                        <div>
                            <button
                                v-if="displayHoldButton"
                                class="uk-button uk-button-dark uk-button-large"
                                @click="$refs.hold.form()"
                            >
                                <i class="material-icons">download</i>
                                보류보관
                            </button>
                            <app-check-set-hold
                                ref="hold"
                                :csrf-token="csrfToken"
                                :prod-id="prod.id"
                                :hold-request="prod.hold_request"
                                @done="callbackHoldDone"
                            >
                            </app-check-set-hold>
                        </div>


                    </div>


                </div>
                <div class="col-2">


                    <div class="uk-flex uk-flex-left uk-flex-bottom">


                        <!-- 합배송경고 -->
                        <div class="merged-shipping-warning uk-margin-small-right" v-if="mergedShipping">
                            (주의) 합배송
                        </div>

                        <!-- 오류 -->
                        <div>
                            <button
                                class="uk-button uk-button-danger"
                                @click="$refs.error.form()"
                            >
                                <i class="material-icons">error</i>
                                오류
                            </button>
                            <app-check-set-error
                                ref="error"
                                :csrf-token="csrfToken"
                                :prod-id="prod.id"
                                :session-owner="loginUserId"
                                @done="callbackErrorDone"
                            ></app-check-set-error>
                        </div>
                    </div>


                </div>
            </div>
        </div>


    </div>

</template>

<script>
export default {
    components: {
        'request': require('../../request-2405.vue').default,
        'img-zoom': require('../../../../common/img-zoom.vue').default,
    },

    props: {
        // csrf-token
        csrfToken: String,

        /**
         * 로그인 유저 ID
         **/
        loginUserId: {
            type: Number,
            default: null,
        },

        /**
         * 상품정보
         */
        prod: {
            type: Object,
            default: null,
        },

        /**
         * 고가상품 기준가격(현지 currency)
         **/
        expensiveLimit: {
            type: Number,
            default: 200,
        },

        /**
         * 트래킹박스 전체 상품카운트
         * 상품품목 수
         * (낱개수량아님)
         **/
        prodTotalCountInTracking: {
            type: Number,
            default: 0,
        },

        /**
         * 트래킹박스 내 현재상품의 인덱스
         * (몇번째 상품인지..)
         *
         * 첫번째 상품 : 1
         **/
        prodIndexInTracking: {
            type: Number,
            default: 0,
        },

        /**
         * 체크박스 disable 여부
         */
        disableCheckbox: {
            type: Boolean,
            default: false,
        },
    },

    data: function () {
        return {};
    },

    computed: {
        /**
         * 보류보관 버튼 표시
         * @return bool
         */
        displayHoldButton: function () {
            return this.prod.lock_hold_req !== null
                && this.prod.state !== 99
                && this.prod.lock_return === null; // 반품신청 없을때만
        },


        /**
         * 정상버튼 표시
         * @return bool
         */
        displayOkButton: function () {
            return this.prod.lock_packed === null
                && this.prod.lock_error === null
                && this.prod.lock_hold === null
                && this.prod.lock_hold_req === null
                && this.prod.lock_pack_ready === null
                && this.prod.state !== 61 // 발송대기
                && this.prod.state !== 99 // 취소
                && this.prod.state !== 127 // 폐기대상
                && this.prod.state !== 128 // 폐기요청
                && this.prod.state !== 129 // 폐기완료
                && this.prod.lock_return === null; // 반품신청 없을때만
        },

        /**
         * 고가상품 여부
         * @return bool
         */
        expensived: function () {
            return this.prod.unit_price >= this.expensiveLimit;
        },

        /**
         * 합배송여부
         * @return bool
         */
        mergedShipping: function () {
            return this.prod.h_prod_count > 1;
        },

        /**
         * 신발여부
         * @return bool
         */
        isShoes: function () {
            return this.prod.hscode
                && this.prod.hscode.startsWith('64');
        },


    },

    methods: {
        /**
         * 에러완료 이벤트 리스너
         */
        callbackErrorDone: function () {
            this.$emit('done:error', null);
        },

        /**
         * 보류완료 이벤트 리스너
         */
        callbackHoldDone: function () {
            this.$emit('done:hold', null);
        },

        /**
         * 정상(발송대기) 이벤트 리스너
         */
        callbackReady: function () {
            this.$emit('done:ready', null);
        },

        /**
         * 정상(패킹대기) 이벤트 리스너
         */
        callbackPack: function (house_id) {
            this.$emit('done:pack', house_id);
        },

    },
}
</script>

<style lang="scss" scoped>
.prod-row {
    padding: 1rem;
    border-bottom: 1px solid #999;


    &:hover {
        //background-color: #e6f5ff;
        background-color: #eee;
    }

    .uk-checkbox {
        margin: 0;
        width: 1.5rem;
        height: 1.5rem;
        background-color: #fff;

        align-self: center;
        flex-shrink: 0;

        &:checked, &:indeterminate {
            background-color: #1e87f0;
        }

        &[disabled] {
            background-color: #EEEEEE;
            border: 1px solid #cccccc;
        }
    }


    .col-img {
        flex-shrink: 0;
    }

    .col-1 {
        width: 50%;
        padding-right: 1rem;
    }

    .col-2 {
        width: 50%;
    }

    // 검수상품정보 테이블
    table {
        width: 100%;
        border-collapse: collapse;
        border-spacing: 0;

        th, td {
            padding: 1px;
            border: 1px solid #cfcfcf;
            text-align: center;

            font-size: 1rem;
            font-weight: normal;
            color: #000;
        }

        th {
            background-color: #fefefe;

            .material-icons {
                display: none;
                vertical-align: middle;
                font-size: 1.25rem;
                color: #aaa;
            }

            &.highlight .material-icons {
                color: #1e87f0 !important;
            }

        }

        td {
            background-color: #fff;

            &.name {
                text-align: center;
            }

            &.unit-price {
                text-align: left;

                .expensived {
                    display: inline-block;
                    margin-left: 1rem;
                    font-size: 1.25rem;
                    color: #ff0000 !important;
                    font-weight: bold;
                }
            }

            &.sku {
                //color: #1e87f0 !important;
                color: #ff0000 !important;

                font-weight: bold;
            }


            &.color, &.size, &.sku {
                font-size: 1.5rem;
                text-align: center;

            }

            &.amount {
                font-size: 2rem;
                text-align: center;

            }

            &.highlight {
                //background-color: #ffffdd;
                background-color: #FFF8E6;


                &.amount {
                    color: #ff0000 !important;
                    font-weight: bold;
                }

                &.sku {
                    background-color: #ffff99;
                }
            }


            // sku 경고
            .sku-warning {
                font-size: 1rem;
                font-weight: normal;
                padding: 0;
                color: #000 !important;
            }

        }


    }

}

// 합배송 경고
.merged-shipping-warning {
    padding: 3px;
    //background-color: #ffffcc;
    background-color: #FFF8E6;
    color: #000;
    border: 1px solid #000;
    font-size: 1rem;
}


// 검수대상 카운트 안내
.prod-count-guide {
    padding: 0;
    color: #999;
    font-size: 1rem;

    &.multi {
        color: #000;

        .current {
            //color: #1e87f0;
            font-size: 1.25rem;
        }

        .total {
            font-size: 1.5rem;
        }
    }

}

// 요청사항
.req-msg:not(:first-child) {
    margin-top: 4px;
}

// 보류안내
.hold-job-guide {
    background-color: #ffd;
    border: 1px solid #ccc;
    padding: 5px;
    color: #000;
    font-size: 0.875rem;

    .strong {
        color: #ff0000;
    }
}

// 신발검수 안내
.shoes-guide {
    color: #ff0000;
    font-size: 1rem;
    margin-top: 0.25rem;
    background-color: #ffffc3;
    display: inline-block;

    .uk-button-xsmall {
        font-size: 0.625rem;
    }
}

// 상품번호 버튼
.prod-detail-button {
    line-height: 1;

}
</style>